<div appDialogSelectable appDialogKeyboardEnabled>
  <div
    class="atlas-fraud-detection-dialog"
    (cdkDragStarted)="dialogBoundryService.handleDragStart($event)"
    (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)"
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDrag
  >
    <div appDialogDragArea cdkDragHandle></div>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">Fraud Detection · {{ data?.caseNumber || '-' }}</div>
        <div class="modal-buttons">
          <div (click)="close()">
            <img src="/assets/icons/Close White.svg" alt="Close" />
          </div>
        </div>
      </div>

      <div *ngIf="!loading && !error && result" class="fraud-calculation-meta">
        <div class="fraud-calculation-meta-label">Calculated</div>
        <div class="fraud-calculation-meta-value">{{ calculationTimestampText }}</div>
        <div *ngIf="result.existing_fraud_detection != null" class="fraud-calculation-meta-badge">
          {{ result.existing_fraud_detection ? 'Existing calculation' : 'New calculation' }}
        </div>
      </div>

      <div class="modal-content-body fraud-detection-dialog-body">
        <div class="fraud-detection-shell">
          <div *ngIf="loading" class="fraud-state-card">
            Loading fraud detection...
          </div>

          <div *ngIf="!loading && error" class="fraud-state-card fraud-state-card-error">
            {{ error }}
          </div>

          <ng-container *ngIf="!loading && !error && result">
            <ng-template #scoreDetailCards let-scoreDetails="scoreDetails">
              <div class="fraud-finding-table-wrap">
                <table class="fraud-finding-table">
                  <colgroup>
                    <col class="fraud-finding-table-rule-column" />
                    <col class="fraud-finding-table-score-column" />
                    <col class="fraud-finding-table-included-column" />
                    <col />
                  </colgroup>
                  <thead>
                    <tr>
                      <th scope="col">Rule</th>
                      <th scope="col">Score / status</th>
                      <th scope="col">Included in score</th>
                      <th scope="col">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let scoreDetail of scoreDetails; trackBy: trackByScoreDetail"
                      class="fraud-finding-row"
                      [ngClass]="[
                        'fraud-finding-row-' + getScoreDetailTone(scoreDetail),
                        scoreDetail.flagged ? 'fraud-finding-row-flagged' : ''
                      ]"
                    >
                      <td class="fraud-finding-rule-cell">
                        <div class="fraud-finding-type">{{ formatScoreRule(scoreDetail.rule) }}</div>
                      </td>
                      <td class="fraud-finding-score-cell">
                        <div
                          class="fraud-finding-score"
                          [ngClass]="'fraud-finding-score-' + getFraudScoreColor(scoreDetail)"
                        >
                          {{ scoreDetail.score }}
                          <span *ngIf="scoreDetail.flagged" class="fraud-finding-score-flag" aria-label="Flagged"></span>
                        </div>
                      </td>
                      <td class="fraud-finding-included-cell">
                        <span
                          class="fraud-finding-included-icon"
                          [ngClass]="scoreDetail.included_in_total ? 'fraud-finding-included-icon-yes' : 'fraud-finding-included-icon-no'"
                          [attr.aria-label]="scoreDetail.included_in_total ? 'Included in score' : 'Not included in score'"
                        ></span>
                      </td>
                      <td class="fraud-finding-description-cell">
                        <div class="fraud-finding-description">{{ scoreDetail.note || '-' }}</div>
                      </td>
                    </tr>
                    <tr
                      *ngFor="let missingInput of missingInputs; trackBy: trackByMissingInput"
                      class="fraud-finding-row fraud-finding-row-missing"
                    >
                      <td class="fraud-finding-rule-cell">
                        <div class="fraud-finding-type">{{ formatScoreRule(missingInput.field) }}</div>
                      </td>
                      <td class="fraud-finding-score-cell">
                        <span class="fraud-missing-input-icon" aria-label="Missing input"></span>
                      </td>
                      <td class="fraud-finding-included-cell">
                        <span
                          class="fraud-finding-included-icon fraud-finding-included-icon-no"
                          aria-label="Not included in score"
                        ></span>
                      </td>
                      <td class="fraud-finding-description-cell">
                        <div class="fraud-finding-description">{{ missingInput.message }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-template>

            <div class="fraud-detection-tab-surface">
              <ul ngbNav #fraudDetectionNav="ngbNav" [(activeId)]="activeTab" class="nav-tabs fraud-detection-tabs">
                <li [ngbNavItem]="'fraudDetection'">
                  <a ngbNavLink>Fraud Detection</a>
                  <ng-template ngbNavContent>
                    <div class="fraud-detection-tab-content">
            <section class="fraud-calculation-disclaimer">
              <span class="fraud-calculation-disclaimer-marker" aria-hidden="true"></span>
              <div class="fraud-calculation-disclaimer-text">
                <ng-container *ngIf="numberOfFlags > 0; else standardFraudCalculationDisclaimer">
                  <div class="fraud-calculation-disclaimer-title">Why this case was flagged</div>
                  <p>
                    This case has been flagged for review because a combination of indicators differs from patterns normally observed in similar cases. This is not produced by AI or other intelligent tools. It is simple rule-based calculation based on statistical patterns and predefined business rules.
                  </p>
                  <div class="fraud-calculation-disclaimer-note">Please note:</div>
                  <ul>
                    <li>The flag is intended to support professional assessment</li>
                    <li>The flag does not constitute evidence of fraud, misconduct or policy breach</li>
                    <li>Normal case handling procedures should still be followed</li>
                  </ul>
                  <a
                    class="fraud-calculation-disclaimer-link"
                    href="https://soseu.sharepoint.com/sites/stash-shared/SitePages/Fraud.aspx"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    See Compass article
                  </a>
                </ng-container>
                <ng-template #standardFraudCalculationDisclaimer>
                  This score is not produced by AI or other intelligent tools. It is a simple rule-based calculation and must not change the normal case handling procedure or be used as a reason to be suspicious of the end user.
                </ng-template>
              </div>
            </section>

            <section class="fraud-score-card" [ngClass]="'fraud-score-card-' + getOverallScoreColor()">
              <div class="fraud-score-tile">
                <div class="fraud-score-label">Score</div>
                <div class="fraud-score-value">{{ result.total_score }}</div>
              </div>
              <div class="fraud-score-factors">
                <div class="fraud-score-factors-header">
                  <div class="fraud-score-factors-title">Fraud indicators</div>
                  <div *ngIf="numberOfFlags > 0" class="fraud-score-flags">
                    <span class="fraud-score-flags-icon" aria-hidden="true"></span>
                    {{ numberOfFlags }} {{ numberOfFlags === 1 ? 'flag' : 'flags' }}
                  </div>
                </div>
                <ng-container *ngIf="fraudScoreFactorMessages.length; else noFraudIndicators">
                  <div
                    *ngFor="let message of fraudScoreFactorMessages"
                    class="fraud-score-factor"
                  >
                    {{ message }}
                  </div>
                </ng-container>
                <ng-template #noFraudIndicators>
                  <div class="fraud-score-factor fraud-score-factor-empty">No fraud indicators</div>
                </ng-template>
              </div>
              <div *ngIf="reviewRequest?.status === 'REVIEW_DONE'" class="fraud-score-review-completed">
                <span class="fraud-review-success-check" [class.fraud-review-success-check-new]="showReviewCompletionSuccess" aria-hidden="true"></span>
                <div>
                  <div class="fraud-review-completed-title">Review completed</div>
                </div>
              </div>
            </section>

            <section *ngIf="fraudNotes" class="fraud-notes-card">
              <div class="fraud-notes-title">Notes</div>
              <div class="fraud-note">{{ fraudNotes }}</div>
            </section>

            <section *ngIf="hasRedFraudDetection && reviewRequest?.status !== 'REVIEW_DONE'" class="fraud-review-card">
              <div *ngIf="reviewRequestLoading" class="fraud-state-card">
                Loading review request...
              </div>

              <div *ngIf="!reviewRequestLoading && reviewRequestError" class="fraud-state-card fraud-state-card-error">
                {{ reviewRequestError }}
              </div>

              <ng-container *ngIf="!reviewRequestLoading && !reviewRequestError && reviewRequest">
                <div *ngIf="reviewRequest.status === 'OPEN'" class="fraud-review-form">
                  <div class="fraud-review-open-title">
                    Open review request
                  </div>

                  <div class="fraud-review-dropdown">
                    <app-drop-down
                      name="Outcome"
                      [items]="reviewOutcomeOptions"
                      [(selectedItemId)]="reviewOutcome"
                      [recommended]="!reviewOutcome"
                      missingItemLabel="Select outcome"
                    ></app-drop-down>
                  </div>

                  <div class="fraud-review-label-row">
                    <label class="fraud-review-label" for="fraud-review-comment">Review comment</label>
                  </div>
                  <div class="fraud-review-comment-guidance">
                    <em>Please document:</em>
                    <ul>
                      <li>Who was involved in the review</li>
                      <li>The review outcome</li>
                    </ul>
                    <p>
                      <em>Example:</em> Discussed with OPS JAJ. Agreed that the indicators were expected due to the customer's medical history. No further fraud investigation required.
                    </p>
                  </div>
                  <textarea
                    id="fraud-review-comment"
                    class="fraud-review-textarea"
                    rows="5"
                    [(ngModel)]="reviewComment"
                    placeholder="Ex: The case was discussed with OPS JAJ."
                  ></textarea>
                  <div *ngIf="reviewSubmitError" class="fraud-review-submit-error">{{ reviewSubmitError }}</div>
                  <button
                    class="fraud-review-submit"
                    type="button"
                    [disabled]="!canSubmitReview"
                    (click)="submitReview()"
                  >
                    {{ reviewSubmitting ? 'Submitting...' : 'Complete review' }}
                  </button>
                </div>

              </ng-container>
            </section>

            <section class="fraud-findings-section">
              <button
                class="fraud-case-inputs-toggle"
                type="button"
                [attr.aria-expanded]="showScoreDetails"
                [class.fraud-case-inputs-toggle-open]="showScoreDetails"
                (click)="toggleScoreDetails()"
              >
                <span>{{ showScoreDetails ? 'Hide score explanations' : 'Show score explanations' }}</span>
                <span class="fraud-findings-toggle-count">
                  {{ scoreDetails.length + missingInputs.length }} {{ scoreDetails.length + missingInputs.length === 1 ? 'entry' : 'entries' }}
                </span>
                <span class="fraud-case-inputs-chevron" [class.fraud-case-inputs-chevron-open]="showScoreDetails" aria-hidden="true"></span>
              </button>

              <div *ngIf="showScoreDetails && (scoreDetails.length || missingInputs.length); else scoreDetailsState" class="fraud-score-details-panel fraud-attached-panel">
                <ng-container
                  *ngTemplateOutlet="scoreDetailCards; context: { scoreDetails: scoreDetails }"
                ></ng-container>
              </div>

              <ng-template #scoreDetailsState>
                <div *ngIf="showScoreDetails" class="fraud-state-card">
                  No score details returned.
                </div>
              </ng-template>

            </section>

            <section *ngIf="documentAnalyses.length" class="fraud-documents-section">
              <button
                class="fraud-case-inputs-toggle"
                type="button"
                [attr.aria-expanded]="showDocuments"
                [class.fraud-case-inputs-toggle-open]="showDocuments"
                (click)="toggleDocuments()"
              >
                <span>{{ showDocuments ? 'Hide documents' : 'Show documents' }}</span>
                <span class="fraud-findings-toggle-count">
                  {{ documentAnalyses.length }} {{ documentAnalyses.length === 1 ? 'document' : 'documents' }} analysed
                </span>
                <span class="fraud-case-inputs-chevron" [class.fraud-case-inputs-chevron-open]="showDocuments" aria-hidden="true"></span>
              </button>

              <div *ngIf="showDocuments" class="fraud-finding-table-wrap fraud-documents-table-panel fraud-attached-panel">
                <table class="fraud-finding-table fraud-document-table">
                  <colgroup>
                    <col class="fraud-document-table-file-column" />
                    <col class="fraud-document-table-format-column" />
                    <col />
                    <col class="fraud-document-table-tags-column" />
                    <col class="fraud-document-table-errors-column" />
                    <col class="fraud-document-table-action-column" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th scope="col">File</th>
                      <th scope="col">Format</th>
                      <th scope="col">Summary</th>
                      <th scope="col">Tags</th>
                      <th scope="col">Errors</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let documentAnalysis of documentAnalyses; trackBy: trackByDocumentAnalysis">
                      <td>
                        <div class="fraud-document-name">{{ documentAnalysis.file_name || '-' }}</div>
                      </td>
                      <td>
                        <div class="fraud-document-format">{{ getDocumentFormat(documentAnalysis) }}</div>
                      </td>
                      <td class="fraud-document-summary">{{ getDocumentSummary(documentAnalysis) }}</td>
                      <td>
                        <span class="fraud-document-tag">{{ getDocumentTags(documentAnalysis) }}</span>
                      </td>
                      <td>
                        <span *ngIf="documentAnalysis.errors?.length; else noDocumentErrors" class="fraud-document-error">
                          {{ documentAnalysis.errors.length }} {{ documentAnalysis.errors.length === 1 ? 'error' : 'errors' }}
                        </span>
                        <ng-template #noDocumentErrors>
                          <span class="fraud-document-empty">-</span>
                        </ng-template>
                      </td>
                      <td>
                        <button
                          class="fraud-document-open"
                          type="button"
                          (click)="openDocumentReport(documentAnalysis, $event)"
                        >
                          Open report
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section class="fraud-case-inputs">
              <button
                class="fraud-case-inputs-toggle"
                type="button"
                [attr.aria-expanded]="showCaseInputs"
                [class.fraud-case-inputs-toggle-open]="showCaseInputs"
                (click)="toggleCaseInputs()"
              >
                <span>{{ showCaseInputs ? 'Hide case inputs' : 'Show case inputs' }}</span>
                <span class="fraud-case-inputs-chevron" [class.fraud-case-inputs-chevron-open]="showCaseInputs" aria-hidden="true"></span>
              </button>

              <div *ngIf="showCaseInputs" class="fraud-request-card fraud-case-inputs-panel fraud-attached-panel">
                <div class="fraud-request-grid">
                  <div class="fraud-request-field">
                    <div class="fraud-request-label">ICD-10</div>
                    <div *ngIf="icd10List.length; else noIcd10List" class="fraud-icd10-list">
                      <div *ngFor="let icd10 of icd10List; trackBy: trackByIcd10" class="fraud-icd10-item">
                        <span class="fraud-icd10-code">{{ icd10.code }}</span>
                        <span class="fraud-icd10-source">{{ icd10.source }}</span>
                      </div>
                    </div>
                    <ng-template #noIcd10List>
                      <div class="fraud-request-value">-</div>
                    </ng-template>
                  </div>
                  <div class="fraud-request-field">
                    <div class="fraud-request-label">Country</div>
                    <div class="fraud-request-value">{{ data?.fields?.country || '-' }}</div>
                  </div>
                  <div class="fraud-request-field">
                    <div class="fraud-request-label">Departure date</div>
                    <div class="fraud-request-value">{{ data?.fields?.departureDate || data?.request?.departure_date || '-' }}</div>
                  </div>
                  <div class="fraud-request-field">
                    <div class="fraud-request-label">Incident date</div>
                    <div class="fraud-request-value">{{ data?.fields?.incidentDate || data?.request?.incident_date || '-' }}</div>
                  </div>
                  <div class="fraud-request-field">
                    <div class="fraud-request-label">Arrival home date</div>
                    <div class="fraud-request-value">{{ data?.fields?.arrivalHomeDate || data?.request?.arrival_home_date || '-' }}</div>
                  </div>
                </div>

                <div class="fraud-request-subsection">
                  <div class="fraud-request-subtitle">Service orders used</div>
                  <div *ngIf="requestServiceOrders.length; else noServiceOrders" class="fraud-request-service-order-list">
                    <article
                      *ngFor="let serviceOrder of requestServiceOrders; trackBy: trackByServiceOrder"
                      class="fraud-request-service-order-card"
                    >
                      <div class="fraud-request-service-order-topline">
                        <div class="fraud-request-service-order-title">
                          {{ serviceOrder.service_type || 'Treatment' }}
                        </div>
                        <div class="fraud-request-service-order-id">#{{ serviceOrder.id || '-' }}</div>
                      </div>
                      <div class="fraud-request-service-order-grid">
                        <div class="fraud-request-service-order-detail">
                          <div class="fraud-request-detail-label">Supplier name</div>
                          <div class="fraud-request-detail-value">{{ serviceOrder.supplier?.name || '-' }}</div>
                        </div>
                        <div class="fraud-request-service-order-detail">
                          <div class="fraud-request-detail-label">Inpatient recommendation</div>
                          <div class="fraud-request-detail-value">{{ serviceOrder.supplier?.inpatient_recommendation || '-' }}</div>
                        </div>
                        <div class="fraud-request-service-order-detail">
                          <div class="fraud-request-detail-label">Outpatient recommendation</div>
                          <div class="fraud-request-detail-value">{{ serviceOrder.supplier?.outpatient_recommendation || '-' }}</div>
                        </div>
                        <div class="fraud-request-service-order-detail">
                          <div class="fraud-request-detail-label">Commitment</div>
                          <div class="fraud-request-detail-value">{{ serviceOrder.commitment_type || '-' }}</div>
                        </div>
                        <div class="fraud-request-service-order-detail">
                          <div class="fraud-request-detail-label">Reserve (EUR)</div>
                          <div class="fraud-request-detail-value">{{ formatMoney(serviceOrder.reserve) }}</div>
                        </div>
                        <div class="fraud-request-service-order-detail">
                          <div class="fraud-request-detail-label">Original cost (EUR)</div>
                          <div class="fraud-request-detail-value">{{ formatMoney(serviceOrder.original_cost) }}</div>
                        </div>
                      </div>
                    </article>
                  </div>

                  <ng-template #noServiceOrders>
                    <div class="fraud-request-empty">No treatment service orders were included.</div>
                  </ng-template>
                </div>
              </div>
            </section>
                  </div>
                  </ng-template>
                </li>
                <li *ngIf="hasPreviousReviews" [ngbNavItem]="'previousReviews'">
                  <a ngbNavLink>
                    Reviews
                  </a>
                  <ng-template ngbNavContent>
                    <div class="fraud-detection-tab-content">
                    <section class="fraud-review-previous-section">
                      <div *ngIf="reviewRequestLoading" class="fraud-state-card">
                        Loading previous reviews...
                      </div>

                      <div *ngIf="!reviewRequestLoading && reviewRequestError" class="fraud-state-card">
                        No previous fraud reviews found for this case.
                      </div>

                      <ng-container *ngIf="!reviewRequestLoading && !reviewRequestError">
                        <div *ngIf="previousReviews.length; else noPreviousReviews" class="fraud-review-previous-list">
                          <article
                            *ngFor="let review of previousReviews; trackBy: trackByReview"
                            class="fraud-review-previous-card"
                          >
                            <div class="fraud-review-previous-header">
                              <div class="fraud-review-previous-outcome">{{ formatReviewOutcome(review.outcome) }}</div>
                              <div class="fraud-review-previous-meta">
                                <span class="fraud-review-previous-date">{{ formatDateTime(review.created_at) }}</span>
                                <span
                                  class="fraud-review-previous-credentials"
                                  [attr.data-tooltip]="getReviewUserName(review)"
                                  [attr.title]="getReviewUserName(review)"
                                  [attr.aria-label]="'Handled by ' + getReviewUserName(review)"
                                  tabindex="0"
                                >
                                  <span class="fraud-review-previous-initials">{{ getReviewUserInitials(review) }}</span>
                                  <app-user-picture
                                    [imageURL]="getReviewUserImage(review)"
                                    [active]="isReviewUserActive(review)"
                                    [imageClass]="'caseSummery'"
                                  ></app-user-picture>
                                </span>
                              </div>
                            </div>

                            <div class="fraud-review-previous-fraud-summary">
                                <div
                                  class="fraud-review-previous-score"
                                  [ngClass]="'fraud-review-previous-score-' + getFraudScoreColor(review)"
                                >
                                  <span class="fraud-review-previous-summary-label">Score</span>
                                  <span class="fraud-review-previous-summary-value">{{ review.fraud_detection_total_score }}</span>
                                </div>

                                <div class="fraud-review-previous-indicators">
                                  <div class="fraud-review-previous-indicators-header">
                                    <span class="fraud-review-previous-indicators-title">Fraud indicators</span>
                                    <span *ngIf="review.fraud_detection_number_of_flags > 0" class="fraud-review-previous-flags">
                                      <span class="fraud-review-previous-flag-icon" aria-hidden="true"></span>
                                      {{ review.fraud_detection_number_of_flags }} {{ review.fraud_detection_number_of_flags === 1 ? 'flag' : 'flags' }}
                                    </span>
                                  </div>
                                  <ng-container *ngIf="getReviewIndicatorMessages(review).length; else noReviewIndicators">
                                    <div
                                      *ngFor="let message of getReviewIndicatorMessages(review)"
                                      class="fraud-review-previous-indicator"
                                    >
                                      <span class="fraud-review-previous-indicator-flag" aria-hidden="true"></span>
                                      <span>{{ message }}</span>
                                    </div>
                                  </ng-container>
                                  <ng-template #noReviewIndicators>
                                    <div class="fraud-review-previous-indicator-empty">No fraud indicators</div>
                                  </ng-template>
                                </div>
                              </div>

                            <div class="fraud-review-previous-comment-block">
                              <div class="fraud-review-previous-comment-label">Review comment</div>
                              <div class="fraud-review-previous-comment">{{ review.comment || '-' }}</div>
                            </div>
                          </article>
                        </div>

                        <ng-template #noPreviousReviews>
                          <div class="fraud-state-card">
                            No previous fraud reviews found for this case.
                          </div>
                        </ng-template>
                      </ng-container>
                    </section>
                  </div>
                  </ng-template>
                </li>
              </ul>
              <div [ngbNavOutlet]="fraudDetectionNav" class="fraud-detection-tab-outlet"></div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
